import TpCreditMemoApplyItem from '../../../../Domain/CreditMemo/TpCreditMemoApplyItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import mathHelper from '../../../../Helpers/mathHelper';
import moneyHelper from '../../../../Helpers/moneyHelper';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import TpCreditMemoLineService from '../../../../Services/CreditMemo/TpCreditMemoLineService';

export default class ApplyCreditWindowDescription {
  static titleForCreate = 'Apply Credit';
  static itemType = TpCreditMemoApplyItem;
  static serviceFunction = (edited) =>
    TpCreditMemoLineService.ApplyCredit(
      edited,
      ApplyCreditWindowDescription.getSelected(),
      ApplyCreditWindowDescription.getSearchParameters(),
      ApplyCreditWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CreditType',
          label: 'Credit Type *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: ApplyCreditWindowDescription.getCreditTypeSelectOptions(),
        },
        {
          fieldName: 'CreditPercentFee',
          label: 'Credit Percent - Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldMinZeroMaxOneHundred,
          hide: (item) => item.CreditType === 'Credit Amount',
        },
        {
          fieldName: 'CreditPercentReimbursement',
          label: 'Credit Percent - Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldMinZeroMaxOneHundred,
          hide: (item) => item.CreditType === 'Credit Amount',
        },
        {
          fieldName: 'CreditAmountFee',
          label: 'Credit Amount - Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ApplyCreditWindowDescription.forDynamicMaximumBaseValue,
          hide: (item) => item.CreditType === 'Credit Percent',
        },
        {
          fieldName: 'CreditAmountReimbursement',
          label: 'Credit Amount - Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ApplyCreditWindowDescription.forDynamicMaximumReimbursementValue,
          hide: (item) => item.CreditType === 'Credit Percent',
        },
        {
          fieldName: (item) => ApplyCreditWindowDescription.getBeforeAmount(item),
          label: 'Net Credit Amount CURRENTLY',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: (item) => ApplyCreditWindowDescription.getAfterAmount(item),
          label: 'Net Credit Amount AFTER SAVING',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static forDynamicMaximumBaseValue(e, editedItem) {
    return ApplyCreditWindowDescription.validateAmount(e, editedItem.BaseFee);
  }

  static forDynamicMaximumReimbursementValue(e, editedItem) {
    return ApplyCreditWindowDescription.validateAmount(e, editedItem.BaseReimbursement);
  }

  static validateAmount(currentValue, maximumValue) {
    if (currentValue < 0) return 'This value has to be at least zero.';
    if (currentValue > maximumValue) return `This value cannot be greater than ${maximumValue}.`;

    return '';
  }

  static getBeforeAmount(item) {
    return moneyHelper.toMoneyFormat(
      mathHelper.ConvertToTwoDecimalNumber(item.LineItemCreditAmount),
      item.CurrencyCode
    );
  }

  static getAfterAmount(item) {
    if (item.CreditType === 'Credit Percent') {
      const calculatedReimb = item.BaseReimbursement * item.CreditPercentReimbursement * 0.01;
      const calculatedFee = item.BaseFee * item.CreditPercentFee * 0.01;

      let calculatedTotal = item.NotSelectedCreditAmount + calculatedReimb + calculatedFee;

      if (calculatedTotal > item.MaxInvoiceAmount) {
        calculatedTotal = item.MaxInvoiceAmount;
      }

      return moneyHelper.toMoneyFormat(mathHelper.ConvertToTwoDecimalNumber(calculatedTotal), item.CurrencyCode);
    }

    let calculatedFee = parseFloat(item.CreditAmountFee);
    calculatedFee = calculatedFee ? calculatedFee : 0;
    if (calculatedFee > item.BaseFee) {
      calculatedFee = item.BaseFee;
    }

    let calculatedReimbursement = parseFloat(item.CreditAmountReimbursement);
    calculatedReimbursement = calculatedReimbursement ? calculatedReimbursement : 0;
    if (calculatedReimbursement > item.BaseReimbursement) {
      calculatedReimbursement = item.BaseReimbursement;
    }

    let calculatedTotal = item.NotSelectedCreditAmount + calculatedFee + calculatedReimbursement;

    if (calculatedTotal > item.MaxInvoiceAmount) {
      calculatedTotal = item.MaxInvoiceAmount;
    }

    return moneyHelper.toMoneyFormat(mathHelper.ConvertToTwoDecimalNumber(calculatedTotal), item.CurrencyCode);
  }

  static getCreditTypeSelectOptions() {
    return selectHelper.generateSelectValues(['Credit Percent', 'Credit Amount']);
  }
}
